module.exports = __webpack_public_path__ + "57dce640ee3bb351c9dbaa24678947f2.svg";